'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Go = void 0;
var $ = require("jquery");
var Go = /** @class */ (function () {
    function Go() {
        var _this = this;
        this.goKey = '#trigGo';
        this.toKey = '#bulletGo';
        $(this.goKey).click(function (e) {
            e.preventDefault();
            var position = $(_this.toKey).offset().top;
            $('body,html').stop().animate({ scrollTop: position }, 300, 'swing');
        });
    }
    return Go;
}());
exports.Go = Go;
exports.default = Go;
